export default{
    "clinics.detail.cart.modalities.title"    : "Méthod de payment",
    "clinics.detail.cart.modalities.subtitle" : "Méthod de payment",
    "clinics.detail.cart.modalities.payNow"   : "Payer maintenant",
    "clinics.detail.cart.modalities.total"    : "Total",
}